import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ProjecaoMensalFlexService = {
    deletarExcelParametros(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/projecao-mensal/excel/deletar', 'excelProjecaoMensalFlexDeletar');
    },
    projecaoMensalFlexExcelPost(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/projecao-mensal/excel', 'excelProjecaoMensalFlex');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('flex/projecao-mensal/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> {
        return Client.post('flex/projecao-mensal/eventGrid', {});
    }
};

export default ProjecaoMensalFlexService;
